import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { BlogGridCard } from 'components/blog/blog-card';

const BlogRelatedSection = ({ article, articles }) => {
	if (!articles.length) return null;

	// Render
	return (
		<section className='mt-16 border-t py-12 md:mt-20 md:py-16'>
			<div className='mb-8 flex-between-bottom gap-4'>
				<div>
					<p className='font-mono text-xs uppercase tracking-[0.16em] text-foreground-body'>{article.tag?.name}</p>
					<h2 className='type-section-title mt-3'>Related articles</h2>
				</div>
				<Link variant='outline' size='xs' href={`/${article.tag?.uuid}`}>
					View all
					<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
				</Link>
			</div>
			<div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3'>
				{articles.map(article => (
					<BlogGridCard key={article.uuid} article={article} />
				))}
			</div>
		</section>
	);
};

export { BlogRelatedSection };
